import {
  StyledDataCell,
  StyledDataRow,
  StyledTableContainer,
} from "../../../../styles/components/tables";
import { TableHead } from "./TableHead";
import { getNestedValue } from "../../../../utils";
import moment from "moment";

import { useTranslation } from "react-i18next";
import { ITableAction } from "../../../../interfaces";
import { SharedButton } from "../../indicators/buttons/SharedButton";
import { ErrorComponent } from "../../../utils/errors/ErrorComponent";
import TableLoadingSkeleton from "../../../utils/loaders/TableLoadingSkelton";





interface ITableContentProps {
  headers: Array<{ key: string; label: string }>;
  data: any;
  rowActions?: Array<ITableAction>; // the actions that can be applied on a row as buttons
  onRowClick: (...args: any) => void;
  isLoading: boolean;
  isError: boolean;
  className?: any;
  onClickParamKey?: string;
}

/**
 *
 * @param props
 * @returns
 */
export const TableContent = ({
  rowActions,
  headers,
  data,
  className,
  isLoading,
  isError,
  onRowClick,
  onClickParamKey = "id",
}: ITableContentProps) => {
  const { t } = useTranslation();
  const handleRowClick = (item: any) => {
    const param = item[onClickParamKey];
    onRowClick(param);
  };
  return (
    <StyledTableContainer>
      <TableHead headers={headers} rowActions={rowActions} />
      {!isLoading && !isError && (
        <tbody>
          {data.length > 0 &&
            data.map((item: any, index: any) => (
              <StyledDataRow key={index} isEven={index % 2 === 0}>
                {headers.map((header: any, key: number) => {
                  const flattenValue = getNestedValue(
                    Object.assign(item, {}),
                    header.key,
                    t
                  );
                  // console.log("flattenValue", header.key, flattenValue);
                  const isEmptyRecord = ["", undefined, null].includes(
                    flattenValue
                  );
                  return (
                    <StyledDataCell
                      onClick={() => handleRowClick(item)}
                      isEmpty={isEmptyRecord}
                      className={className}
                    >
                      {/* {console.log(header.key, item)} */}
                      {}
                      {isEmptyRecord
                        ? "- - - -"
                        : [
                              "createdAt",
                              "user.birthDate",
                              "updatedAt",
                              "deletedAt",
                            ].includes(header.key)
                          ? moment(flattenValue).format("DD-MM-YYYY")
                          : flattenValue}
                    </StyledDataCell>
                  );
                })}

                <div className="flex gap-1 justify-center items-center">
                  {rowActions?.length && rowActions?.length > 0 ? (
                    <>
                      {rowActions.map((action: ITableAction) => (
                        <SharedButton
                          onClick={() => {
                            action.handler(item.id, item);
                          }}
                          icon={action.buttonIcon}
                          children={<>{action.buttonText}</>}
                          className={`${action.buttonColor} flex justify-center items-center rounded-lg gap-3 text-white text-sm w-max px-8`}
                        />
                      ))}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </StyledDataRow>
            ))}

          {data.length == 0 && (
            <tr>
              <td colSpan={headers.length} style={{ textAlign: "center" }}>
                {/* <NoRecordFound
                  type="custom"
                  message="Aucun patient n'est trouvé"
                /> */}
              </td>
            </tr>
          )}
        </tbody>
      )}

      {isLoading && (
        <>
          <TableLoadingSkeleton columnsNumber={headers?.length} />{" "}
        </>
      )}
      {isError && (
        <>
          <ErrorComponent />{" "}
        </>
      )}
    </StyledTableContainer>
  );
};
